import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageContainer from '../components/common/PageContainer';

/**
 * FAQPage - Frequently Asked Questions page
 * Follows React Rules: State management for accordion, pure render logic
 */
const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: 'Mauris congue euismod purus at semper. Morbi et vulputate massa?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Donec mattis finibus elit ut tristique?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Vestibulum a lorem placerat, porttitor urna vel?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Aenean elit orci, efficitur quis nisl at, accumsan?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Pellentesque habitant morbi tristique senectus et netus?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Nam pellentesque aliquam metus?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    },
    {
      question: 'Aenean elit orci, efficitur quis nisl at, accumsan?',
      answer: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven\'t heard of them accusamus labore sustainable VHS.'
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <PageContainer>
      {/* Breadcrumb */}
      <div className="breadcrumb-area">
        <div className="container">
          <div className="breadcrumb-content">
            <ul>
              <li><Link to="/store">Home</Link></li>
              <li className="active">FAQ</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Frequently Area */}
      <div className="frequently-area pt-60 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="frequently-content">
                <div className="frequently-desc">
                  <h3>Below are frequently asked questions, you may find the answer for yourself</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id erat sagittis, 
                    faucibus metus malesuada, eleifend turpis. Mauris semper augue id nisl aliquet, 
                    a porta lectus mattis. Nulla at tortor augue. In eget enim diam. Donec gravida 
                    tortor sem, ac fermentum nibh rutrum sit amet. Nulla convallis mauris vitae 
                    congue consequat. Donec interdum nunc purus, vitae vulputate arcu fringilla quis. 
                    Vivamus iaculis euismod dui.
                  </p>
                </div>
              </div>

              {/* Frequently Accordion */}
              <div className="frequently-accordion">
                <div id="accordion">
                  {faqs.map((faq, index) => (
                    <div key={index} className={`card ${openIndex === index ? 'actives' : ''}`}>
                      <div className="card-header" id={`heading${index}`}>
                        <h5 className="mb-0">
                          <a
                            className={openIndex === index ? '' : 'collapsed'}
                            href={`#collapse${index}`}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleAccordion(index);
                            }}
                            aria-expanded={openIndex === index}
                            aria-controls={`collapse${index}`}
                          >
                            {faq.question}
                          </a>
                        </h5>
                      </div>
                      <div
                        id={`collapse${index}`}
                        className={`collapse ${openIndex === index ? 'show' : ''}`}
                        aria-labelledby={`heading${index}`}
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default FAQPage;
